// extracted by mini-css-extract-plugin
module.exports = {"container":"styles_container__zc38-","seaText":"styles_seaText__MAJhb"};